import React, { useRef } from 'react';
import { Text } from '@consta/uikit/Text';
import { locationNotApi } from 'src/utils/api';
import { storageTelegramBotLink, storagePublishUrl } from 'src/utils/storage';
import { Button } from '@consta/uikit/Button';
import { IconCopy } from '@consta/uikit/IconCopy';
import QRCode from 'qrcode.react';

import cn from 'classnames/bind';
import styles from './styles.styl';

const cx = cn.bind(styles);

export interface IQRCodeProps {}

const QRCodeLink: React.FC<IQRCodeProps> = () => {
  const qrRef = useRef<HTMLDivElement>();

  const downloadQRCode = (evt: React.FormEvent) => {
    evt.preventDefault();
    if (qrRef.current) {
      const canvas = qrRef.current.querySelector('canvas');
      const image = canvas.toDataURL('image/png');
      const anchor = document.createElement('a');
      anchor.href = image;
      anchor.download = `qr-code.png`;
      document.body.appendChild(anchor);
      anchor.click();
      document.body.removeChild(anchor);
    }
  };

  return (
    <>
      <Text className={cx('QRCodeLink__titleText')}>Ссылка на опрос</Text>
      <div className={cx('QRCodeLink__urlContainer')}>
        <Text
          className={cx('QRCodeLink__urlText')}
          truncate={true}
          view="ghost"
        >
          {`${locationNotApi}/walkthrough/${storagePublishUrl()}`}
        </Text>
        <Button
          className={cx('QRCodeLink__button')}
          size="s"
          view="ghost"
          iconRight={IconCopy}
          onlyIcon
          onClick={() =>
            navigator.clipboard.writeText(
              `${locationNotApi}/walkthrough/${storagePublishUrl()}`,
            )
          }
        />
      </div>
      <Text className={cx('QRCodeLink__titleText')}>
        Ссылка на прохождение опроса в Telegram
      </Text>
      <div className={cx('QRCodeLink__urlContainer')}>
        <Text
          className={cx('QRCodeLink__urlText')}
          truncate={true}
          view="ghost"
        >
          {storageTelegramBotLink()}
        </Text>
        <Button
          className={cx('QRCodeLink__button')}
          size="s"
          view="ghost"
          iconRight={IconCopy}
          onlyIcon
          onClick={() =>
            navigator.clipboard.writeText(storageTelegramBotLink())
          }
        />
      </div>

      <div ref={qrRef} className={cx('QRCodeLink__code')}>
        <QRCode
          id="qrCodeElToRender"
          size={1000}
          value={`${locationNotApi}/walkthrough/${storagePublishUrl()}`}
          bgColor="white"
          fgColor="#141926"
          level={'H'}
        />
      </div>
      <Button
        className={cx('QRCodeLink__buttonDownload')}
        size="m"
        view="primary"
        label="Скачать QR-код"
        onClick={downloadQRCode}
      />
    </>
  );
};

export default QRCodeLink;
